/* Shared media loading and icon fallback. Purchase and playback handlers stay native. */
(() => {
  if (window.tapedPerformanceInitialized) return;
  window.tapedPerformanceInitialized = true;
  // Same original glyphs, trimmed to the page/cart icons. Unknown icons added
  // through theme settings or app rendering load the original full face.
  const subsetIcons = new Set('add arrow_back arrow_forward check check_circle circle close credit_card done info keyboard_arrow_down keyboard_arrow_up local_shipping lock redeem remove schedule sell shopping_bag star verified warning check_box error shield undo'.split(' '));
  function checkIcon(element) {
    if (!element?.matches?.('.material-symbols-outlined')) return;
    const name = element.textContent.trim();
    element.classList.toggle('tv2-icon-full', Boolean(name && !subsetIcons.has(name)));
  }
  function scanIcons(root) {
    checkIcon(root);
    root.querySelectorAll?.('.material-symbols-outlined').forEach(checkIcon);
  }
  function loadVideoPoster(video) {
    const url = video.dataset.tapedVideoPoster;
    if (!url) return;
    video.poster = url;
    delete video.dataset.tapedVideoPoster;
    posterObserver?.unobserve(video);
  }
  const posterObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.isIntersecting) loadVideoPoster(entry.target); });
    }, {rootMargin:'600px 0px'}) : null;
  function visit(root, selector, callback) {
    if (root.matches?.(selector)) callback(root);
    root.querySelectorAll?.(selector).forEach(callback);
  }
  function scan(root) {
    scanIcons(root);
    visit(root, 'video[data-taped-video-poster]', video => {
      if (posterObserver) posterObserver.observe(video);
      else loadVideoPoster(video);
    });
  }
  function release(root) {
    visit(root, 'video[data-taped-video-poster]', video => posterObserver?.unobserve(video));
  }
  // One observer covers app-rendered icons, carousel clones and editor sections.
  const observer = new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'characterData') checkIcon(record.target.parentElement);
      else {
        checkIcon(record.target);
        record.removedNodes.forEach(node => { if (node.nodeType === 1) release(node); });
        record.addedNodes.forEach(node => { if (node.nodeType === 1) scan(node); });
      }
    });
  });
  scan(document);
  observer.observe(document.documentElement, {childList:true, characterData:true, subtree:true});
  document.addEventListener('shopify:section:unload', event => release(event.target));
})();
